var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.498,
    height: 96.882,
    viewBox: "0 0 91.498 96.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "giftbox",
    transform: "translate(11.635 -0.455) rotate(11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5374",
    "data-name": "Group 5374",
    transform: "translate(2.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9029",
    "data-name": "Path 9029",
    d: "M47.248,10.553S36.7,0,24.441,0c-7.149,0-9.872,4.766-9.872,9.531s2.893,9.531,8.17,9.531h24.51Z",
    transform: "translate(-14.569)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9030",
    "data-name": "Path 9030",
    d: "M47.248,10.553S36.7,0,24.441,0c-7.149,0-9.872,4.766-9.872,9.531s2.893,9.531,8.17,9.531h24.51Z",
    transform: "translate(-14.569)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9031",
    "data-name": "Path 9031",
    d: "M297.626,10.553S308.179,0,320.434,0c7.149,0,9.872,4.766,9.872,9.531s-2.893,9.531-8.17,9.531h-24.51Z",
    transform: "translate(-251.33)",
    fill: "#fbe77b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M80.47,130.169H3.271A3.271,3.271,0,0,1,0,126.9v-7.074a3.271,3.271,0,0,1,3.271-3.271h77.2a3.271,3.271,0,0,1,3.271,3.271V126.9A3.271,3.271,0,0,1,80.47,130.169Z",
    transform: "translate(0 -97.49)",
    fill: "#fb636f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M484.943,116.552v13.616H486a3.37,3.37,0,0,0,3.37-3.37v-6.877a3.37,3.37,0,0,0-3.37-3.37h-1.055Z",
    transform: "translate(-405.627 -97.489)",
    fill: "#fa4954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M193.561,116.553h20.425v13.616H193.561Z",
    transform: "translate(-161.903 -97.49)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M98.676,250.867H30.328a3.271,3.271,0,0,1-3.271-3.271V199.8h74.89V247.6A3.271,3.271,0,0,1,98.676,250.867Z",
    transform: "translate(-22.632 -167.125)",
    fill: "#fb636f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9036",
    "data-name": "Path 9036",
    d: "M27.057,199.8h74.89v4.085H27.057Z",
    transform: "translate(-22.632 -167.125)",
    fill: "#fa4954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M214.374,199.8H227.99v51.062H214.374Z",
    transform: "translate(-179.312 -167.125)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9038",
    "data-name": "Path 9038",
    d: "M214.374,199.8H227.99v4.085H214.374Z",
    transform: "translate(-179.312 -167.125)",
    fill: "#fcdd2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9039",
    "data-name": "Path 9039",
    d: "M302.391,56.137a1.7,1.7,0,0,1-1.572-1.049c.439-.161.913-.319,1.4-.458a1.264,1.264,0,1,0-.686-2.433c-.29.082-.573.169-.849.26V48.393a36.537,36.537,0,0,0-3.064,2.638v8.51h24.51a7.494,7.494,0,0,0,6.371-3.4Z",
    transform: "translate(-248.946 -40.478)",
    fill: "#fcdd2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9040",
    "data-name": "Path 9040",
    d: "M53.386,48.393v4.064c-.275-.091-.559-.178-.849-.26a1.264,1.264,0,1,0-.686,2.433c.49.138.964.3,1.4.458a1.7,1.7,0,0,1-1.572,1.049H25.569a7.493,7.493,0,0,0,6.371,3.4h24.51v-8.51a36.538,36.538,0,0,0-3.064-2.638Z",
    transform: "translate(-21.387 -40.478)",
    fill: "#fcdd2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9041",
    "data-name": "Path 9041",
    d: "M227.99,60.844H214.374v-8.6a2.29,2.29,0,0,1,2.29-2.29H225.7a2.29,2.29,0,0,1,2.29,2.29Z",
    transform: "translate(-179.312 -41.781)",
    fill: "#fbe77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9042",
    "data-name": "Path 9042",
    d: "M214.374,95.74H227.99v3.4H214.374Z",
    transform: "translate(-179.312 -80.081)",
    fill: "#fcdd2e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftbox);
export default __webpack_public_path__ + "static/media/giftbox.26677f35.svg";
export { ForwardRef as ReactComponent };